function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_6983",
  "data-name": "Path 6983",
  d: "M9.014,128.889v1.387h.693v5.547H1.387v-5.547H2.08v-1.387H0v8.321H11.094v-8.321Z",
  transform: "translate(0 -126.115)",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_6984",
  "data-name": "Path 6984",
  d: "M140.206,2.654V6.241h1.387V2.654l.9.9.98-.98L140.9,0l-2.57,2.57.98.98Z",
  transform: "translate(-135.352 0)",
  fill: "#fff"
});

function SvgExport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "export",
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.094,
    height: 11.094,
    viewBox: "0 0 11.094 11.094",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.ffd06225.svg";
export { ForwardRef as ReactComponent };